<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
  <div>
    <h5 class="mb-1 fw-bold">Raw Material Entries</h5>
    <span class="sub-text">History of raw material receipts</span>
  </div>
  <button class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2" (click)="openExportModal()">
    <i class="bi bi-download"></i>
    Export Report
  </button>
</div>

<div class="alert alert-info d-flex align-items-start mb-3" role="alert">
  <i class="bi bi-info-circle-fill me-2 mt-1"></i>
  <div>
    <strong>Entries are managed from the Purchase Order section.</strong>
    To correct an entry, update its purchase order. To remove an entry, delete the associated purchase order: the raw
    material inventory stock adjusts automatically.
  </div>
</div>

<!-- Filters -->
<div class="row g-2 mb-4">
  <!-- Search -->
  <div class="col-12 col-md-4 ps-0">
    <div class="input-group">
      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search text-muted"></i>
      </span>
      <input
        type="text"
        class="form-control border-start-0"
        placeholder="Search by material name..."
        [(ngModel)]="searchTerm"
        (keyup)="onSearchKeyUp()" />
    </div>
  </div>

  <!-- Category -->
  <div class="col-12 col-md-2-5 col-lg-2">
    <ng-select
      [items]="categories"
      bindLabel="name"
      bindValue="id"
      placeholder="All Categories"
      [(ngModel)]="selectedCategory"
      (change)="onFilterChange()"
      [clearable]="true"
      class="ng-select-sm"></ng-select>
  </div>

  <!-- Supplier -->
  <div class="col-12 col-md-2-5 col-lg-2">
    <ng-select
      [items]="suppliers"
      bindLabel="name"
      bindValue="id"
      placeholder="All Suppliers"
      [(ngModel)]="selectedSupplier"
      (change)="onFilterChange()"
      [clearable]="true"
      class="ng-select-sm"></ng-select>
  </div>

  <div class="col-12 col-md-2-5 col-lg-2 pe-0">
    <ng-select
      [items]="wareHouses"
      bindLabel="name"
      bindValue="id"
      placeholder="All Warehouses"
      [(ngModel)]="selectedWarehouse"
      (change)="onWareHouseSelected(selectedWarehouse!)"
      [clearable]="true"
      [disabled]="currentUser?.role !== UserRole.ADMIN"
      class="ng-select-sm"></ng-select>
  </div>

  <!-- Company -->
  <div class="col-12 col-md-2-5 col-lg-2">
    <ng-select
      [items]="companies"
      bindLabel="name"
      bindValue="id"
      placeholder="All Companies"
      [(ngModel)]="selectedCompany"
      (change)="onFilterChange()"
      [clearable]="true"
      class="ng-select-sm"></ng-select>
  </div>
</div>

@if (isRawMaterialEntriesDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  @if ((rawMaterialEntries || []).length === 0) {
    <div class="text-center py-4 text-muted">
      <app-info-alert>No raw material entries found.</app-info-alert>
    </div>
  } @else {
    <div class="table-responsive">
      <app-table [columns]="entryColumns" [data]="rawMaterialEntries"></app-table>
    </div>
  }
}

@if ((rawMaterialEntries || []).length > 0) {
  <div class="mt-4">
    <app-pagination
      [currentPage]="currentPage"
      [totalCount]="totalCount"
      [pageSize]="10"
      [hasNextPage]="hasNextPage"
      [hasPreviousPage]="hasPreviousPage"
      (pageChange)="onPageChange($event)"></app-pagination>
  </div>
}

<!-- Export Modal -->
<ng-template #exportModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">Export Raw Material Entries</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (exportError) {
      <app-error-alert [error]="exportError" class="mb-3"></app-error-alert>
    }

    <div class="row g-3">
      <!-- Date Range -->
      <div class="col-6">
        <label class="form-label">From Date</label>
        <input type="date" class="form-control" [(ngModel)]="exportFromDate" />
      </div>
      <div class="col-6">
        <label class="form-label">To Date</label>
        <input type="date" class="form-control" [(ngModel)]="exportToDate" />
      </div>

      <!-- Warehouse -->
      <div class="col-12">
        <label class="form-label">Warehouse</label>
        <ng-select
          [items]="wareHouses"
          bindLabel="name"
          bindValue="id"
          placeholder="All Warehouses"
          [(ngModel)]="exportWarehouse"
          [clearable]="true"></ng-select>
      </div>

      <!-- Category -->
      <div class="col-12">
        <label class="form-label">Category</label>
        <ng-select
          [items]="categories"
          bindLabel="name"
          bindValue="id"
          placeholder="All Categories"
          [(ngModel)]="exportCategory"
          [clearable]="true"></ng-select>
      </div>

      <!-- Raw Material -->
      <div class="col-12">
        <label class="form-label">Raw Material</label>
        <ng-select
          [items]="rawMaterials"
          bindLabel="name"
          bindValue="id"
          placeholder="All Raw Materials"
          [(ngModel)]="exportRawMaterial"
          [clearable]="true"
          [searchable]="true"></ng-select>
      </div>

      <!-- Company -->
      <div class="col-12">
        <label class="form-label">Company</label>
        <ng-select
          [items]="companies"
          bindLabel="name"
          bindValue="id"
          placeholder="All Companies"
          [(ngModel)]="exportCompany"
          [clearable]="true"></ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()" [disabled]="isExporting">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2"
      (click)="onExportSubmit(modal)"
      [disabled]="isExporting">
      @if (isExporting) {
        <span class="spinner-border spinner-border-sm"></span>
        Exporting...
      } @else {
        <i class="bi bi-download"></i>
        Export
      }
    </button>
  </div>
</ng-template>
